import React from "react";
import ReactDOM from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "reduxjs-toolkit-persist/integration/react";
import { configureStoreFn } from "./redux/store";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "react-toastify/dist/ReactToastify.css";
//import "font-awesome/css/font-awesome.min.css";
import "./assets/fonts/font-awesome.min.css";
// import "./assets/default/main.css";
import "./assets/default/globalMessageStyles.css";
import MainApp from "./Routes";

const { store, persister } = configureStoreFn();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
  <BrowserRouter forceRefresh={true}>
    <PersistGate persistor={persister}>
      <ErrorBoundary>
        <CookiesProvider>
            <MainApp />
        </CookiesProvider>
      </ErrorBoundary>
    </PersistGate>
    </BrowserRouter>
  </Provider>
);
